// Todo: get data from api
export function ApprovedReviewsPage() {
  return <h1>Hello</h1>
}
